import { Component } from '@angular/core';
//import { emitKeypressEvents } from 'readline';
@Component({
    selector: 'app-physician-orders',
    templateUrl: './physician-orders.component.html',
    styleUrls: ['./physician-orders.component.scss'],
    standalone: false
})
export class PhysicianOrdersComponent {
  comments!: string;
  instruction!: string;
  reasons!: string;
  wasscanned!: string;
  scanrequired!: string;
  medication!: string;
  patientName!: string;
  infusion = false
  infusion_rate!:string;
  infusion_start!:Date;
  infusion_end!:Date;
  infusion_rate_uom!:string;

  loadOrderData(row: any){
    this.patientName = row['patientName']
    this.comments = row['AdminComments']

    if(row['SecondInstruction'] != undefined){
      this.instruction = row['FirstInstruction'] + row['SecondInstruction']
    }
    else if(row['FirstInstruction'] != undefined){
      this.instruction = row['FirstInstruction']
    }
    else{
      this.comments = ''
    }

    if(row['SecondReason'] != undefined){
      this.reasons = row['FirstReason'] + row['SecondReason']
    }
    else if(row['FirstReason'] != undefined){
      this.reasons = row['FirstReason']
    }
    else{
      this.reasons = ''
    }


    this.medication = row['medDesc']
    if(row['ScanRequired'] == 1){
      this.scanrequired = 'Yes'
    }
    else{
      this.scanrequired = 'No'
    }
    if(row['WasScanned']== 1){
      this.wasscanned = 'Yes'
    }
    else{
      this.wasscanned = 'No'
    }
    if(row['infusion_rate'] != undefined){
      this.infusion=true
      this.infusion_rate = row['infusion_rate'].toString() + ' ' + row['infusion_uom']
      // this.infusion_rate_uom = row['infusion_uom']
      this.infusion_start = row['infusion_start_time']
      this.infusion_end = row['infusion_stop_time']
    }
  }
}
